import React from 'react'
import ApplicantInput from 'modules/react/loan-calculator/content/ApplicantInput'
import Title from 'modules/react/loan-calculator/content/Title'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'

export default function Applicant ({ applicant, index }) {

  const { setApplicantValue } = React.useContext(LoanCalculatorContext)
  const { firstName, lastName, phone, email } = applicant

  return (
    <div className='lc-applicant'>
      <Title black={true}>Ansøger</Title>
      <div className='lc-applicant__inputs'>
        <ApplicantInput
          name='Fornavn*'
          id='firstName'
          type='text'
          placeholder='F.eks. Hans'
          defaultValue={firstName}
          onChange={(e) => setApplicantValue('firstName', e.target.value)}
          required
        />
        <ApplicantInput
          name='Efternavn*'
          id='lastName'
          type='text'
          placeholder='F.eks. Jensen'
          defaultValue={lastName}
          onChange={(e) => setApplicantValue('lastName', e.target.value)}
          required
        />
        <ApplicantInput
          name='Mobil*'
          id='phone'
          type='tel'
          prefix='+45'
          placeholder='F.eks. 12 34 56 78'
          defaultValue={phone}
          onChange={(e) => setApplicantValue('phone', e.target.value)}
          required
        />
        <ApplicantInput
          name='Email*'
          id='email'
          type='email'
          placeholder='F.eks. HansJensen@email.dk'
          defaultValue={email}
          onChange={(e) => setApplicantValue('email', e.target.value)}
          required
        />
      </div>
    </div>
  )
}
